import script from "./SubscriptionExpired.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionExpired.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionExpired.vue?vue&type=style&index=0&id=684784e9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-684784e9"]])

export default __exports__